module.exports = __webpack_public_path__ + "static/media/simulation-years-info.95f24756.svg";